import { destroy, get, post } from '.';
import qs from 'qs';

export const getSettingRequests = ({ filters }) => {
  return get(`/setting-requests?${qs.stringify(filters)}`);
};

export const getSettingRequest = ({ settingRequestId }) => {
  return get(`/setting-requests/${settingRequestId}`);
};

export const createSettingRequest = ({ payload }) => {
  return post(`/setting-requests`, payload);
};

export const deleteSettingRequest = ({ settingRequestId, payload }) => {
  return destroy(`/setting-requests/${settingRequestId}`, payload);
};
